<template>
  <div>
    <div style="display: flex;align-items: center;margin-top: 10px;">
      <span>销售人员:{{ salesManager }}</span>
      <div style="margin-left: auto;" v-if="isEdit">
        <Button type="primary" icon="ios-add" @click="goAdd">新增收款账户</Button>
        <Button icon="md-refresh" @click="refresh" style="margin-left: 10px">刷新</Button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix" style="margin-top: 20px;">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          max-height="300"
          border="none"
          align="center"
          :loading="loading"
          :data="listData"
      >
        <vxe-table-column field="index" title="序号" width="60">
          <template slot-scope="{ $rowIndex }">
            <span>{{ $rowIndex + 1 }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="recName" title="收款人" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="phoneNum" title="手机号码" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="idcardNum" title="身份证号码" show-overflow></vxe-table-column>
        <vxe-table-column field="bankName" title="开户银行" show-overflow></vxe-table-column>
        <vxe-table-column field="accountNum" title="银行账号" show-overflow></vxe-table-column>
        <vxe-table-column field="" title="操作" show-overflow v-if="isEdit">
          <template slot-scope="{ row }">
            <span style="cursor:pointer;color: #2d8cf0;" @click="goEdit(row)">编辑</span>
            <span style="cursor:pointer;color: red;margin-left: 10px;" @click="commitDelete(row.id)">删除</span>
            <span v-if="row.isDefault === 1" style="margin-left: 10px;">默认</span>
            <span v-else style="cursor:pointer;color: #2d8cf0;margin-left: 10px;"
                  @click="setDefault(row.id)">设为默认</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="add-btn-box">
      <Button type="primary" @click="isEdit = true" v-if="!isEdit && isHavePermission('baseUserSalesManager:edit')">编辑</Button>
    </div>
    <vxe-modal v-model="createModal" :title="createTile" width="700" height="500" resize destroy-on-close
               @close="createModal = false" remember>
      <create-sales-manager ref="createModal" @afterSave="afterSave"
                            @close="createModal = false" :isInAdd="true"></create-sales-manager>
    </vxe-modal>
  </div>
</template>
<script>
import CreateSalesManager from "@/views/authorization/CreateSalesManager";
import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  components: {CreateSalesManager},
  data() {
    return {
      loading: false,
      listData: [],
      salesManager: null,
      salesManagerId: null,
      isEdit: false,
      createTile: '',
      createModal: false
    }
  },
  methods: {
    afterSave() {
      this.createModal = false;
      this.refresh();
    },
    setUpdate(row) {
      this.isEdit = true;
      this.init(row);
    },
    goAdd() {
      this.createModal = true;
      this.$nextTick(()=>{
        this.$refs.createModal.setSalesManager(this.salesManager,this.salesManagerId);
      })
    },
    init(row) {
      this.salesManager = row.salesManager;
      this.salesManagerId = row.salesManagerId;
      this.getList();
    },
    refresh() {
      this.getList();
    },
    async getList() {
      this.loading = true;
      let res = await $api.baseUserSalesManager.request("querySalesManagerDetail", {
        rows: 10000,
        page: 1,
        salesManagerId: this.salesManagerId
      });
      this.loading = false;
      if (res.status === 1) {
        this.listData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    goEdit(row) {
      this.createModal = true;
      this.$nextTick(()=>{
        this.$refs.createModal.setUpdate(row);
      })
    },
    commitDelete(id) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.remove(id);
        }
      })
    },
    async remove(id) {
      showLoading();
      let res = await $api.baseUserSalesManager.request("removeSalesManagerId", {id});
      hideLoading()
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    async setDefault(id) {
      showLoading();
      let res = await $api.baseUserSalesManager.request("setSalesManagerDefault", {id});
      hideLoading()
      if (res.status === 1) {
        this.$Message.success("设置成功");
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    }
  }
}
</script>
<style>

</style>